import { render, staticRenderFns } from "./ProjectTypes.vue?vue&type=template&id=44762048&"
import script from "./ProjectTypes.vue?vue&type=script&lang=js&"
export * from "./ProjectTypes.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTypes.vue?vue&type=style&index=0&id=44762048&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports